var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-menu',{attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"activator",fn:function({ attrs, on }){return [_c('app-btn',_vm._g(_vm._b({staticClass:"text-lowercase mr-2"},'app-btn',attrs,false),on),[_c('span',{domProps:{"textContent":_vm._s(`v${_vm.version}`)}}),_c('app-chevron-down')],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }